export default function SectionHeading({ overline, title, subtitle, align = "left", id }) {
  return (
    <div
      id={id}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <div className="overline">{overline}</div>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-3 text-white">
        {title}
      </h2>
      <div className={`divider-gold ${align === "center" ? "mx-auto" : ""}`} />
      {subtitle && (
        <p className="text-slate-300 text-base lg:text-lg leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
